export default "__VITE_ASSET__CJM$VtjK__"